import { faUpRightAndDownLeftFromCenter } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import { React } from 'Imports';

const SmallViewPlayOverlay = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 10,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: 'rgba(0, 120, 211, 0.8)',
                '&:hover': {
                    backgroundColor: 'rgba(0, 120, 211, 1)',
                },
            }}
        >
            <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} fontSize={'14px'} style={{ color: 'white' }} />
        </Box>
    );
};

export default SmallViewPlayOverlay;
